import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../api';

interface GetClaimsParams {
  status?: string;
  page?: number;
  take?: number;
}

export const doGetClaims = createAsyncThunk<any, GetClaimsParams>('claims/doGetClaims', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetClaims(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateClaim = createAsyncThunk<any, any>('claims/doUpdateClaim', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateClaim(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
